var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"nav"},[_c('router-link',{attrs:{"to":{ name: 'editor-list', params: {} }}},[_vm._v("Shows")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }